import { useCallback, useEffect, useState } from 'react';
import { isBefore } from 'date-fns';
import { warn } from '@adsk/alloy-react-helpers';
import { getRangeValue, isPropControlled } from '../helpers';
function useDateRangeSelection(_ref) {
  let {
    initialStartDate,
    initialEndDate,
    propsStartDate,
    propsEndDate,
    propsOnChange,
    allowSameStartAndEndDate,
    onFinalSelection,
    setShouldShowSelection
  } = _ref;
  const [stateStartDate, setStateStartDate] = useState(initialStartDate);
  const [stateEndDate, setStateEndDate] = useState(initialEndDate);
  const startDate = isPropControlled(propsStartDate) ? propsStartDate : stateStartDate;
  const endDate = isPropControlled(propsEndDate) ? propsEndDate : stateEndDate;
  const isControlled = isPropControlled(propsStartDate) || isPropControlled(propsEndDate);
  useEffect(() => {
    if (isControlled && endDate && startDate && isBefore(endDate, startDate)) {
      warn('DateRangePicker: provided `endDate` is before provided `startDate` - this usage is not supported.');
    }
  }, [isControlled, endDate, startDate]);
  const onDateSelected = useCallback((_ref2, updateActiveMonths) => {
    let {
      selectable,
      date: newlySelectedDate
    } = _ref2;
    if (!selectable) {
      return;
    } else if (isControlled) {
      setShouldShowSelection(true);
      const selectedDates = getRangeValue({
        newlySelectedDate,
        startDate: propsStartDate,
        endDate: propsEndDate,
        allowSameStartAndEndDate
      });
      propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange(selectedDates);
      const {
        startDate: nextStartDate,
        endDate: nextEndDate
      } = selectedDates;
      if (nextStartDate && nextEndDate) {
        onFinalSelection();
        updateActiveMonths(true, null, nextStartDate, nextEndDate);
      }
    } else {
      const selectedDates = getRangeValue({
        newlySelectedDate,
        startDate: stateStartDate,
        endDate: stateEndDate,
        allowSameStartAndEndDate
      });
      setShouldShowSelection(true);
      propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange(selectedDates);
      const {
        startDate: nextStartDate,
        endDate: nextEndDate
      } = selectedDates;
      setStateStartDate(nextStartDate);
      setStateEndDate(nextEndDate);
      if (nextStartDate && nextEndDate) {
        onFinalSelection();
        updateActiveMonths(true, null, nextStartDate, nextEndDate);
      }
    }
  }, [allowSameStartAndEndDate, isControlled, propsEndDate, propsStartDate, stateEndDate, stateStartDate, propsOnChange, onFinalSelection, setShouldShowSelection]);
  const resetSelection = useCallback(() => {
    propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange({
      startDate: null,
      endDate: null
    });
    if (!isControlled) {
      setStateStartDate(null);
      setStateEndDate(null);
    }
  }, [isControlled, propsOnChange]);
  return {
    startDate,
    endDate,
    onDateSelected,
    resetSelection
  };
}
export default useDateRangeSelection;
//# sourceMappingURL=useDateRangeSelection.js.map